<template>
  <footer
    class="relative flex flex-col justify-center items-center gap-20 p-[2%]"
  >
    <div
      class="sm:gap-x-6 grid grid-cols-2 md:grid-cols-12 w-full text-base row-gap"
    >
      <div class="flex flex-col md:col-span-6">
        <p
          class="pb-2 border-flax-smoke-400 border-b w-full font-bold heading-5"
        >
          Menu
        </p>
        <div class="space-y-1 mt-2">
          <p v-for="i in navbarLinks" class="heading-6">
            <Link
              class="h-6 font-medium tracking-wider"
              :label="i.label"
              :url="i.url"
            />
          </p>
        </div>
      </div>

      <div class="flex flex-col md:col-span-3">
        <p
          class="pb-2 border-flax-smoke-400 border-b w-full font-bold heading-5"
        >
          Socials
        </p>

        <div class="space-y-1 mt-2">
          <p v-for="i in socialLinks" :key="i.label" class="heading-6">
            <Link :target="i.target"
              class="h-6 font-medium tracking-wider"
              :label="i.label"
              :url="i.url"
            />
          </p>
        </div>
      </div>

      <!-- <div class="flex flex-col col-span-full md:col-span-3">
        <p
          class="pb-2 border-flax-smoke-400 border-b w-full font-bold heading-5"
        >
          Resources
        </p>
        <div class="space-y-1 mt-2">
          <p v-for="i in resourceLinks" class="heading-6">
            <Link
              class="font-medium lowercase tracking-wider"
              :label="i.label"
              :url="i.url"
            />
          </p>
        </div>
      </div> -->
    </div>

    <div class="grid grid-cols-12 w-full">
      <div class="place-content-center col-span-7 md:col-span-6">
        <h6 class="font-bold leading-none heading-4 sm:heading-2">
          © {{ new Date().getFullYear() }} JSLORENZO <br />
          All rights reserved.
        </h6>
      </div>

      <div
        class="place-content-center max-sm:place-content-end col-span-5 md:col-span-3"
      >
        <p class="font-bold uppercase heading-6">JSLORENZO's Local time</p>
        <p class="heading-6">{{ userLocalTime }}</p>
    
      </div>

      <div
        class="hidden md:block md:col-span-2 lg:col-span-1 md:col-start-11 lg:col-start-12"
      >
        <MagneticEffect divId="scroll-to-top" textId="scroll-to-top-icon">
          <div
            @click="lenis.scrollTo('#app', { duration: 2 })"
            id="scroll-to-top"
            class="flex-col flex-center bg-flax-smoke-400 rounded-full size-20 cursor-pointer"
          >
            <svg
              class="size-1/2"
              id="scroll-to-top-icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              color="#000000"
              fill="none"
            >
              <path
                d="M12 4L12 20"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16.9998 8.99996C16.9998 8.99996 13.3174 4.00001 11.9998 4C10.6822 3.99999 6.99982 9 6.99982 9"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </MagneticEffect>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
  import { navbarLinks, socialLinks } from '@/data';
  import { Link } from '..';
  import { onMounted, ref } from 'vue';
  import { lenis } from '@/main';
  import MagneticEffect from '../MagneticEffect.vue';
  import moment from 'moment-timezone';


  const userLocalTime = ref('');

  onMounted(() => {
   
        

    // User's local time (based on their location)
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    userLocalTime.value = moment.tz(userTimeZone).format('h:mm:ss a');
    setInterval(() => {
      userLocalTime.value = moment.tz(userTimeZone).format('h:mm:ss a');
    }, 1000);
  });
</script>
